import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/home/runner/_work/landfolk/landfolk/apps/design-system/app/_components/client-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SharedFonts"] */ "/home/runner/_work/landfolk/landfolk/apps/design-system/app/_components/client-shared-fonts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollbarSizeStyles"] */ "/home/runner/_work/landfolk/landfolk/apps/design-system/app/_components/scrollbar-size-styles.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/landfolk/landfolk/apps/design-system/global.css");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/landfolk/landfolk/node_modules/.pnpm/next@14.2.35_@babel+core@7.25.9_@opentelemetry+api@1.9.0_@playwright+test@1.51.1_react-dom@18_7vvs7slvxtbxurj2nsiyb5y2cu/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/landfolk/landfolk/node_modules/.pnpm/swiper@11.0.7/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/landfolk/landfolk/node_modules/.pnpm/swiper@11.0.7/node_modules/swiper/modules/pagination.css");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/landfolk/landfolk/packages/styling/global.css");
